// eslint-disable-next-line import/prefer-default-export
export const productsFields = [
  {
    key: 'name',
    label: 'Produk di Gudang Kompack',
    thClass: '!normal-case !font-[500] !text-[14px] !font-[#333333]',
  },
  {
    key: 'action',
    label: 'Aksi',
    thClass: '!w-[180px] !normal-case !font-[500] !text-[14px] !font-[#333333]',
  },
]
